import React from 'react';
import TopQuestion from '../../utils/question/topQuestion';
import SpeechRecorder from './saSpeechRecorder';
import TextArea from '../../utils/test/textarea';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
	const { leftSectionProps } = state.rootReducer.testPageDetails;

	return {
		leftSectionProps,
	};
};

const SaSpeech = ({ leftSectionProps: { domain, prompt } }) => (
	<section className="que-container">
		<section className="quiz-page-content">
			<TopQuestion />
			<section className="quiz-area-options">
				<h6>{prompt}</h6>
				{domain === 'S' ? <SpeechRecorder /> : <TextArea />}
			</section>
		</section>
	</section>
);

export default connect(mapStateToProps)(SaSpeech);
